export default "__VITE_PUBLIC_ASSET__04bdb5fd__"